module.exports = __webpack_public_path__ + "static/img/man_stu.fa687f6d.png";